import axios from 'axios'
import history from '../history'


const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
// const HEADERS = {
//     'Content-Type': 'application/json'
// };

export async function postUpdateVaga(id, cargo, pcd, atividades, requisitos,
    salarioMin, salarioMax, beneficios, regime, numeroVagas, vigenciaVaga, confidential, uf, cidadeSelecionada, dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/job/updateopportunity',
        {
            "id": id,
            "title": cargo,
            "requirement": requisitos,
            "description": atividades,
            "benefit": beneficios,
            "salary_min": salarioMin,
            "salary_max": salarioMax,
            "city": {
                "id": cidadeSelecionada.id,
                "code": cidadeSelecionada.code,
                "state": {
                    "id": cidadeSelecionada.state_id,
                    "uf": uf
                }
            },
            "quantity": numeroVagas,
            "isPdc": pcd,
            "vigency": vigenciaVaga,
            "type": regime,
            "confidential": confidential
        },
        {
            headers: {
                'Authorization': AuthToken
            }
        }).then(response => {
            successPostUpdateVaga(response, dispatch);
        }).catch(erro => {
            erroPostUpdateVaga(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successPostUpdateVaga(response, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Alterar Vaga',
        description: 'Vaga alterada com sucesso'
    })
    history.push('/gerenciar-vagas')
}

function erroPostUpdateVaga(erro, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Alterar Vaga',
        description: 'Houve um erro ao tentar enviar os dados'
    })
}